import React, { useCallback } from 'react'

import {
  Check, CrownFilled, Icon, ShapeHexagon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, oneOf, shape, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import formatPrice from 'Utils/formatPrice'

const TRANSLATION_KEY_PREFIX = 'subscription_checkout.plans_restructure.plan_card'

const FEATURE_SLOTS = ['first', 'second', 'third']

const CHECK_SIZE = { width: '16', height: '16' }

const GLYPH_SIZE = { width: '11', height: '11' }

const TIER_GLYPHS = {
  essentials: ShapeHexagon,
  premium: CrownFilled,
}

function PlanCard({
  tier, plan, catalogValue = '', locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(`${TRANSLATION_KEY_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  return (
    <div className="checkout-plan-card">
      <div className="checkout-plan-card__header">
        <div className="checkout-plan-card__heading">
          <div className="checkout-plan-card__title">
            <span className="cgt-body-md-semibold">{translate(`names.${tier}`)}</span>
            <span
              className={classnames('checkout-plan-card__tier-mark', `checkout-plan-card__tier-mark--${tier}`)}
              aria-hidden="true"
            >
              <Icon
                svgComponent={TIER_GLYPHS[tier]}
                size={GLYPH_SIZE}
                className={classnames('checkout-plan-card__tier-glyph', `checkout-plan-card__tier-glyph--${tier}`)}
                notSpaced
              />
            </span>
          </div>
          <span className="checkout-plan-card__term cgt-caption">{translate(`terms.${plan.key}`)}</span>
        </div>
        <div className="checkout-plan-card__pricing">
          <span className="checkout-plan-card__price cgt-heading-100">{formatPrice(plan.price)}</span>
          <span className="checkout-plan-card__price-label cgt-caption">{translate(`per_term.${plan.key}`)}</span>
        </div>
      </div>
      <ul className="checkout-plan-card__features">
        {FEATURE_SLOTS.map((slot) => (
          <li key={slot} className="checkout-plan-card__feature cgt-body-base">
            <Icon svgComponent={Check} color="primary" size={CHECK_SIZE} notSpaced />
            <span>{translate(`features.${tier}.${slot}`, {
              modelCount: catalogValue,
              downloads: plan.downloadsPerMonth,
              generations: plan.generationsPerMonth,
            })}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

PlanCard.propTypes = {
  tier: oneOf(['essentials', 'premium']).isRequired,
  plan: shape({
    key: string.isRequired,
    price: number,
    downloadsPerMonth: number,
    generationsPerMonth: number,
  }).isRequired,
  catalogValue: string,
  locale: string,
}

export default PlanCard
